import { createStyles, makeStyles } from "@mui/styles";
import { CommonFonts, Colors } from "@/theme";

const useStyles = makeStyles((theme) =>
  createStyles({
    trendText: {
      fontSize: 14,
      fontWeight: "bold",
    },
  })
);

export default useStyles;
